var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as storesAction from '../actions/store.actions';
import { switchMap, mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { isNullOrUndefined } from 'util';
import { StoreService } from '../../store.service';
var StoreEffects = /** @class */ (function () {
    function StoreEffects(actions, storeService, store) {
        var _this = this;
        this.actions = actions;
        this.storeService = storeService;
        this.store = store;
        this.getAllStores = this.actions.ofType(storesAction.GET_ALL_STORES)
            .pipe(switchMap(function () {
            return _this.storeService.getAllStores()
                .map(function (res) { return new storesAction.GetAllStoresSuccess(res); })
                .catch(function (error) { return of(new storesAction.GetAllStoresError(error)); });
        }));
        this.getStore = this.actions.ofType(storesAction.GET_STORE)
            .pipe(withLatestFrom(
        // select stores.
        this.store.select(function (state) { return state.storesFeature.stores.entities; }), function (action, stores) {
            // if no stores present, proceed for API.
            if (isNullOrUndefined(stores)) {
                return action;
            }
            else {
                // stores exists in store.
                var store = stores.filter(function (s) { return s.id === action.payload; })[0];
                if (!!store) {
                    // if required store is present in store, then return;
                    return undefined;
                }
                else {
                    // if required store not present in store, then proceed for API.
                    return action;
                }
            }
        }), filter(function (action) { return !!action; }), mergeMap(function (action) {
            return _this.storeService.getStore(action.payload)
                .map(function (res) { return new storesAction.GetStoreSuccess(res); })
                .catch(function (error) { return of(new storesAction.GetStoreError(error)); });
        }));
        this.registerStore = this.actions.ofType(storesAction.ADD_STORE)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (body) {
            return _this.storeService.registerStore(body)
                .map(function (res) { return new storesAction.AddStoreSuccess(res); })
                .catch(function (error) { return of(new storesAction.AddStoreError(error)); });
        }));
        this.updateStore = this.actions.ofType(storesAction.UPDATE_STORE)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (body) {
            return _this.storeService.updateStore(body)
                .map(function (res) { return new storesAction.UpdateStoreSuccess(res); })
                .catch(function (error) { return of(new storesAction.UpdateStoreError(error)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], StoreEffects.prototype, "getAllStores", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], StoreEffects.prototype, "getStore", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], StoreEffects.prototype, "registerStore", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], StoreEffects.prototype, "updateStore", void 0);
    return StoreEffects;
}());
export { StoreEffects };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/stores/store/effects/store.effects.ts.pre-build-optimizer.js